import React, { useRef, useEffect } from 'react';
import { Button } from 'antd-mobile';
import _ from 'lodash';
import './index.scss';

const MemberCard = (props) => {
  const propsRef = useRef();

  const {
    id,
    roomId,
    title,
    connected,
    audioMute,
    speaking,
    handleSpeak,
    handleConnect,
    handleDisConnect,
    handleMuteAudio,
  } = props;

  const muteAudio = () => {
    const operation = propsRef.current.audioMute === true ? 'unmute' : 'mute';
    handleMuteAudio({ id, roomId, operation });
  };

  const connect = () => {
    if (propsRef.current.connected === 'connected') {
      handleDisConnect({ id: propsRef.current.id, roomId: propsRef.current.roomId });
    } else {
      handleConnect({ id: propsRef.current.id, roomId: propsRef.current.roomId });
    }
  };

  const speak = () => {
    const operation = propsRef.current.speaking === '1' ? '0' : '1';
    handleSpeak({ id: propsRef.current.id, roomId: propsRef.current.roomId, operation });
  };

  const _speak = useRef(
    _.debounce(() => {
      speak();
    }, 500),
  ).current;

  const _connect = useRef(
    _.debounce(() => {
      connect();
    }, 500),
  ).current;

  const _muteAudio = useRef(
    _.debounce(() => {
      muteAudio();
    }, 500),
  ).current;

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  const isConnected = connected === 'connected';
  return (
    <div
      className={`conference-member-list-wrapper-card ${
        isConnected && speaking === '1' ? 'on' : ''
      } ${isConnected ? '' : 'off'} `}
    >
      <div className="member-card-top" onClick={_speak}>
        <div className="member-card-title">{title}</div>
        <div className="member-card-icon"></div>
      </div>
      <div className="member-card-control">
        <span className="member-card-button" onClick={_muteAudio}>
          <em className={`microphone ${isConnected && audioMute ? 'of' : 'on'}`}></em>
        </span>
        {/* <span className="member-card-button" onClick={handleMuteSpeak}>
                    <em className={`loudspeaker ${loudspeaker}`}></em>
                </span> */}
        <span className="member-card-button" onClick={_connect}>
          <em className="telephone"></em>
        </span>
      </div>
    </div>
  );
};

const MemberColCard = (props) => {
  const { id, roomId, title, handleClick } = props;

  const onClick = () => {
    const operation = 0;
    handleClick({ id, roomId, operation });
  };

  const _onClick = useRef(
    _.debounce(() => {
      onClick();
    }, 500),
  ).current;

  return (
    <div className="member-col-card">
      <div className="member-col-icon">
        <em></em>
      </div>
      <div className="member-col-title">{title}</div>
      <Button onClick={_onClick} className="member-col-speak on">
        取消发言
      </Button>
    </div>
  );
};

export { MemberCard, MemberColCard };
